import { IChipsOption } from '@cian/ui-kit';
import { ERoom } from '../../types/filter';

export const roomsOptions: IChipsOption<ERoom>[] = [
  { label: 'Студия', value: ERoom.Studio },
  { label: '1', value: ERoom.OneRoom },
  { label: '2', value: ERoom.TwoRoom },
  { label: '3+', value: ERoom.ThreeRoom },
];
